const actionTypes = {
    SetSnackbar: "Set snackbar",
    HideSnackbar: "Hide snackbar"
}

const initialState = {
    showSnackbar: false,
    snackbarType: "success",
    snackbarMessage: ""
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SetSnackbar: {
            const {variant, message} = action.payload;

            return {
                ...state,
                showSnackbar: true,
                snackbarType: variant,
                snackbarMessage: message
            }
        }
        case actionTypes.HideSnackbar: {
            return {
                ...state, showSnackbar: false
            }
        }

        default: {
            return state
        }
    }
}

export const actions = {
    setSnackbar: ({variant, message}) => ({
        type: actionTypes.SetSnackbar,
        payload: {variant, message}
    }),
    hideSnackbar: () => ({
        type: actionTypes.HideSnackbar
    })
}